export default __webpack_public_path__ + "1207e55ee34a633970eb94f45464058d.svg";